import styled from "styled-components";

export const AlarmWrap = styled.span`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  cursor: default;
`;

export const Duration = styled.span`
  display: inline-block;
  width: 5.5em;
  text-align: center;
`;

export const AlarmIcon = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 200%;
  line-height: 1;
  position: relative;
  top: -2px;
`;

export const RefreshIcon = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 200%;
  line-height: 1;
  position: relative;
  top: -3px;
  cursor: pointer;
`;
